export enum ShippingStopKindEnum {
  PICKUP = 'pickup',
  DROPOFF = 'dropoff',
}
